<template>
<div class="part-assets">
    <table>
        <thead>
            <tr>
                <th v-if="showClass">Class</th>
                <th>Model</th>
                <th>Action</th>
                <th>Animation</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(part, i) in sortedParts" :key="i">
                <td v-if="showClass" class="job">{{ className(part) }}</td>
                <td class="asset">{{ modelName(part) }}</td>
                <td class="asset">{{ lower(part.actName) }}</td>
                <td class="asset">{{ lower(part.aniName) }}</td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script>
//  A part's clsid is a jobtable BASE CLASS, not a job id — note Vandar is job
//  id 201 but baseClass 10, so this cannot be a job-id lookup. The base class
//  list is static, so it's mapped here rather than fetched. Names are the
//  jobtable's own (id 5 is "Tinkerer", not Academic; id 8 is "Lencea").
const BASE_CLASS_NAMES = {
    1: "Warrior",
    2: "Archer",
    3: "Sorceress",
    4: "Cleric",
    5: "Tinkerer",
    6: "Kali",
    7: "Assassin",
    8: "Lencea",
    9: "Machina",
    10: "Vandar",
};

export default {
    props: ["parts"],
    computed: {
        //  Same ordering the model part picker used, so rows stay comparable
        //  with what the decal preview shows.
        sortedParts() {
            if (!this.parts || !this.parts.parts) {
                return [];
            }

            return this.parts.parts.slice().sort((a, b) => a.clsid - b.clsid);
        },
        //  Single-part items (most weapons) carry clsid -1 and need no column;
        //  multi-part items are one row per class, so the rows need labelling.
        showClass() {
            return this.sortedParts.length > 1;
        },
    },
    methods: {
        lower(name) {
            return name ? String(name).toLowerCase() : "–";
        },
        //  A part carries either a model (skn) or a decal, never both.
        modelName(part) {
            return this.lower(part.sknName || part.decalName);
        },
        //  Prefer the part's own job when the dataset carries one; otherwise
        //  resolve the clsid. The raw id stays visible either way — this table
        //  is tech-mode only, and an unmapped class should still be readable.
        className(part) {
            if (part.job && part.job.name) {
                return part.job.name.message;
            }

            const name = BASE_CLASS_NAMES[part.clsid];
            return name ? `${name} (${part.clsid})` : `(${part.clsid})`;
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../less/core.less";
@import "../../less/common/variables.less";

.part-assets {
    td.asset {
        font-family: monospace;
        color: @dv-c-tech;
    }

    td.job {
        white-space: nowrap;
    }
}
</style>
